<template>
  <div id="BrandIndex">
    <CommonTabbar :tabbarActive="tabbarActive"></CommonTabbar>
  </div>
</template>

<script>
export default {
  name: 'BrandIndex',
  data() {
    return {
      tabbarActive: 2,
    }
  },
}
</script>